import { render, staticRenderFns } from "./sailing-holidays.vue?vue&type=template&id=619028d6&scoped=true"
import script from "./sailing-holidays.vue?vue&type=script&lang=ts"
export * from "./sailing-holidays.vue?vue&type=script&lang=ts"
import style0 from "./sailing-holidays.vue?vue&type=style&index=0&id=619028d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619028d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
